var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYearnCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84 42C84 65.196 65.196 84 42 84C18.804 84 0 65.196 0 42C0 18.804 18.804 0 42 0C65.196 0 84 18.804 84 42Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7898 42.2674C80.7898 63.5427 63.5428 80.7897 42.2675 80.7897C20.9923 80.7897 3.74524 63.5427 3.74524 42.2674C3.74524 20.9921 20.9923 3.74512 42.2675 3.74512C63.5428 3.74512 80.7898 20.9921 80.7898 42.2674Z",
    fill: "#1967FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0001 69.019C56.9223 69.019 69.0192 56.9222 69.0192 41.9999C69.0192 27.0777 56.9223 14.9808 42.0001 14.9808C27.0778 14.9808 14.9809 27.0777 14.9809 41.9999C14.9809 56.9222 27.0778 69.019 42.0001 69.019ZM42.0001 72.7643C58.9907 72.7643 72.7644 58.9906 72.7644 41.9999C72.7644 25.0093 58.9907 11.2356 42.0001 11.2356C25.0094 11.2356 11.2357 25.0093 11.2357 41.9999C11.2357 58.9906 25.0094 72.7643 42.0001 72.7643Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0765 18.8749L27.0409 16.5859L41.9033 35.8339L46.1571 30.6709H50.8299L41.8511 41.8944L24.0765 18.8749Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4424 22.4121L65.4302 24.6703L48.4204 47.1757V71.6941H44.6752V45.9195L62.4424 22.4121Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7344 47.116L23.5414 31.0317L28.2439 31.0319L39.4796 45.8569V72.168L35.7344 68.4228V47.116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearnCoin);
export default __webpack_public_path__ + "static/media/yearn-coin.718a61d7a101fc6727fc21a8145e495f.svg";
export { ForwardRef as ReactComponent };